//toda vez que precisamos alterar uma informação passamos pelo reducer
//primeira coisa que criamos é uma interface para tipar os dados que teremos na store
//criar interface dentro do reducer

import { createReducer, on } from '@ngrx/store';
import { IProfession } from 'src/app/shared/interfaces/profession/iprofession';
import {
  loadProfession,
  loadProfessionSuccess,
  saveProfessionSuccess,
} from './profession.actions';

export interface IProfessionState {
  lista: IProfession[];
  isLoading: boolean
}

const initialState: IProfessionState = {
  lista: [],
  isLoading: false
};

export const professionReducer = createReducer(
  initialState,
  on(loadProfession, (state) => ({
    ...state,
    isLoading: true
  })),
  on(loadProfessionSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
    isLoading: false
  })),

  on(saveProfessionSuccess, (state, { profession }) => ({
    ...state,
    lista: [...state.lista, profession],
  }))
);
//colocar como parametro o professionReducer lá no app.module
//agora criamos o selector em um novo arquivo
